<template>
  <v-container class='pessoas'>
    <v-card
      class="py-4 px-2 auth-content"
      tile
    >
      <v-form
        v-model="valid"
        ref="form"
        autocomplete="no"
      >
        <PageTitle
          icon="mdi-pencil-box-outline"
          main="Assistência Social"
          sub="Cadastro de pessoas"
          home="/social"
        />
        <input
          id="user-id"
          type="hidden"
          v-model="pessoa.usuario"
        />
        <input
          id="pessoa-id"
          type="hidden"
          v-model="pessoa.id"
        />
        <input
          id="pessoa-uuid"
          type="hidden"
          v-model="pessoa.uuid"
        />
        <input
          id="pessoa-esic"
          type="hidden"
          v-model="pessoa.esic"
        />
        <v-row>
          <v-col
            cols="12"
            md="2"
          >
            <v-text-field
              v-model="codigo"
              label="Código"
              dense
              filled
            >
              <v-icon
                slot="append"
                color="success"
                large
                @click="loadDialog"
              >
                mdi-magnify
              </v-icon>
            </v-text-field>
          </v-col>
          <v-col
            cols="12"
            md="3"
            v-if="codigo"
          >
            <v-checkbox
              v-model="pessoa.inativar"
              label="Inativar pessoa?"
              color="success"
              v-show="mode === 'save'"
            ></v-checkbox>
          </v-col>
          <v-col
            cols="12"
            md="3"
            v-if="codigo"
          >
            <v-btn
              color="default"
              @click.prevent="altPass"
            >
              <v-icon
                left
                color="green"
              >
                mdi-account-key
              </v-icon>
              Redefinir senha
            </v-btn>
          </v-col>
        </v-row>
        <v-row class="pl-1">
          <v-col
            cols="12"
            lg="4"
            md="4"
            sm="12"
          >
            <v-autocomplete
              v-model="pessoa.tipo_pessoa"
              :items="tPessoa"
              label="Tipo de pessoa"
              required
              outlined
              dense
              @change="loadFuncaoPessoa()"
            ></v-autocomplete>
          </v-col>
          <input
            id="pessoa-cgc"
            type="hidden"
            v-model="pessoa.cgc"
          />
          <v-col
            cols="12"
            lg="4"
            md="4"
            sm="12"
            v-if="verCpf === true"
          >
            <v-text-field
              v-model="pessoa.cgc_txt"
              name="cpf"
              label="CPF"
              type="text"
              outlined
              dense
              required
              @blur="formataCpf()"
            >
            </v-text-field>
          </v-col>
          <v-col
            cols="12"
            lg="4"
            md="4"
            sm="12"
            v-if="tipo === 'pfisica'"
          >
            <v-text-field
              v-model="pessoa.rg"
              label="Rg"
              type="text"
              outlined
              dense
            >
            </v-text-field>
          </v-col>
          <v-col
            cols="12"
            lg="4"
            md="4"
            sm="12"
            v-if="verCnpj === true"
          >
            <v-text-field
              v-model="pessoa.cgc_txt"
              type="text"
              label="CNPJ"
              outlined
              dense
              required
              @blur="formataCnpj()"
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row class="pl-1">
          <v-col
            cols="12"
            lg="8"
            md="6"
            sm="12"
          >
            <v-text-field
              v-model="pessoa.nome"
              type="text"
              required
              :label="`${nameLabel}`"
              outlined
              dense
            >
            </v-text-field>
          </v-col>
          <v-col
            cols="12"
            lg="5"
            md="6"
            sm="12"
            v-if="tipo === 'pjuridica'"
          >
            <v-text-field
              v-model="pessoa.fantasia"
              type="text"
              label="Nome fantasia"
              outlined
              dense
            >
            </v-text-field>
          </v-col>
          <v-col
            cols="12"
            lg="4"
            md="3"
            sm="12"
            v-if="tipo === 'pfisica'"
          >
            <v-text-field
              v-model="pessoa.nis"
              type="text"
              label="NIS:"
              outlined
              dense
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row
          class="pl-1"
          v-if="tipo === 'pfisica'"
        >
          <v-col
            cols="12"
            lg="3"
            md="6"
            sm="12"
            v-if="tipo === 'pfisica'"
          >
            <v-text-field
              v-model="pessoa.data_nascimento"
              type="date"
              label="Data de Nascimento :"
              outlined
              dense
            >
            </v-text-field>
          </v-col>
          <v-col
            cols="12"
            lg="3"
            md="6"
            sm="12"
          >
            <v-autocomplete
              v-model="pessoa.estado_civil"
              :items="estadoCivil"
              label="Estado civil"
              required
              outlined
              dense
            >
            </v-autocomplete>
          </v-col>
          <v-col
            cols="12"
            lg="3"
            md="6"
            sm="12"
          >
            <v-autocomplete
              v-model="pessoa.genero"
              :items="genero"
              label="Gênero"
              required
              outlined
              dense
            >
            </v-autocomplete>
          </v-col>
          <v-col
            cols="12"
            lg="3"
            md="6"
            sm="12"
          >
            <v-autocomplete
              v-model="pessoa.raca"
              :items="raca"
              label="Raça/cor"
              required
              outlined
              dense
            >
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row
          class="pl-1"
          v-if="tipo === 'pfisica'"
        >
          <v-col
            cols="12"
            lg="6"
            md="6"
            sm="12"
          >
            <v-autocomplete
              v-model="pessoa.escolaridade"
              :items="instrucao"
              label="Escolaridade"
              required
              outlined
              dense
            >
            </v-autocomplete>
          </v-col>
          <v-col
            cols="12"
            lg="6"
            md="6"
            sm="12"
          >
            <v-text-field
              v-model="pessoa.profissao"
              type="text"
              label="Profissão :"
              outlined
              dense
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row
          class="pl-1"
          v-if="tipo === 'pfisica'"
        >
          <v-col
            cols="12"
            lg="5"
            md="3"
            sm="12"
          >
            <v-autocomplete
              v-model="pessoa.nacionalidade_uf"
              :items="estados"
              label="Estado de origem"
              required
              outlined
              dense
              @change="loadCidadesOrig()"
            >
            </v-autocomplete>
          </v-col>
          <v-col
            cols="12"
            lg="7"
            md="6"
            sm="12"
          >
            <v-autocomplete
              clearable
              v-model="pessoa.nacionalidade_cidade"
              :items="cidades"
              label="Cidade de origem"
              required
              outlined
              dense
              :disabled="!pessoa.nacionalidade_uf"
            >
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row class="pl-1">
          <v-col
            cols="12"
            lg="7"
            md="6"
            sm="12"
            v-if="tipo === 'pjuridica'"
          >
            <v-text-field
              v-model="pessoa.responsavel"
              type="text"
              label="Nome do responsável"
              outlined
              dense
            >
            </v-text-field>
          </v-col>
          <v-col
            cols="12"
            lg="5"
            md="6"
            sm="12"
            v-if="tipo === 'pjuridica'"
          >
            <v-text-field
              v-model="pessoa.cargo_responsavel"
              type="text"
              label="Cargo :"
              outlined
              dense
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row class="pl-1">
          <v-col
            cols="12"
            lg="6"
            md="6"
            sm="12"
          >
            <v-text-field
              clearable
              v-model="pessoa.email"
              type="email"
              required
              label="E-mail"
              outlined
              dense
            >
            </v-text-field>
          </v-col>
          <v-col
            cols="12"
            lg="3"
            md="6"
            sm="12"
          >
            <v-text-field
              v-model="pessoa.fone"
              autocomplete="off"
              type="text"
              label="Telefone"
              outlined
              dense
            >
            </v-text-field>
          </v-col>
          <v-col
            cols="12"
            lg="3"
            md="6"
            sm="12"
          >
            <v-text-field
              v-model="pessoa.celular"
              autocomplete="off"
              type="text"
              label="Celular:"
              outlined
              dense
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row
          class="pl-1"
          v-if="!codigo"
        >
          <v-col
            cols="12"
            lg="6"
            md="6"
            sm="12"
          >
            <v-text-field
              clearable
              v-model="pessoa.password"
              :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
              :rules="[rules.required, rules.min]"
              :type="show1 ? 'text' : 'password'"
              @click:append="show1 = !show1"
              label="Senha"
              hint="Deve conter pelo menos 6 caracteres"
              required
              outlined
              dense
            >
            </v-text-field>
          </v-col>
          <v-col
            cols="12"
            lg="6"
            md="6"
            sm="12"
          >
            <v-text-field
              v-model="pessoa.confirmPassword"
              :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
              :rules="[rules.required]"
              :type="show2 ? 'text' : 'password'"
              @click:append="show2 = !show2"
              label="Confirmação da senha:"
              outlined
              dense
            >
            </v-text-field>
          </v-col>
        </v-row>
        <div v-if="tipo === 'pfisica'">
          <span class="info-ad">Dados da filiação</span>
          <hr class="mb-2" />
        </div>
        <v-row
          class="pl-1"
          v-if="tipo === 'pfisica'"
        >
          <v-col
            cols="12"
            lg="10"
            md="10"
            sm="12"
          >
            <v-text-field
              v-model="pessoa.mae"
              type="text"
              label="Nome da mãe"
              outlined
              dense
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row
          class="pl-1"
          v-if="tipo === 'pfisica'"
        >
          <v-col
            cols="12"
            lg="10"
            md="10"
            sm="12"
          >
            <v-text-field
              v-model="pessoa.pai"
              type="text"
              label="Nome do pai"
              outlined
              dense
            >
            </v-text-field>
          </v-col>
        </v-row>
        <span class="info-ad">Informações adicionais/ Endereço atual</span>
        <hr class="mb-2" />
        <v-row class="pl-1">
          <v-col
            cols="12"
            lg="6"
            md="6"
            sm="12"
            v-if="tipo === 'pjuridica'"
          >
            <v-autocomplete
              v-model="pessoa.tipo_instituicao"
              :items="instituicao"
              label="Tipo de instituição"
              required
              outlined
              dense
            >
            </v-autocomplete>
          </v-col>
          <v-col
            cols="12"
            lg="6"
            md="6"
            sm="12"
            v-if="tipo === 'pjuridica'"
          >
            <v-autocomplete
              v-model="pessoa.area_atuacao"
              :items="atuacao"
              label="Àrea de atuação"
              required
              outlined
              dense
            >
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row class="pl-1">
          <v-col
            cols="12"
            lg="3"
            md="3"
            sm="12"
          >
            <v-autocomplete
              v-model="pessoa.uf"
              :items="estados"
              label="Estado"
              required
              outlined
              dense
              @change="loadCidades()"
            >
            </v-autocomplete>
          </v-col>
          <v-col
            cols="12"
            lg="6"
            md="6"
            sm="12"
          >
            <v-autocomplete
              clearable
              v-model="pessoa.cidade"
              :items="cidades"
              label="Cidade"
              required
              outlined
              dense
              :disabled="!pessoa.uf"
            >
            </v-autocomplete>
          </v-col>
          <v-col
            cols="12"
            lg="3"
            md="3"
            sm="12"
          >
            <v-text-field
              v-model="pessoa.cep"
              type="text"
              label="Cep"
              outlined
              dense
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row class='pl-1'>
          <v-col
            cols="12"
            lg="9"
            md="9"
            sm="12"
          >
            <v-text-field
              v-model="pessoa.bairro"
              type="text"
              label="Bairro"
              outlined
              dense
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row class="pl-1">
          <v-col
            cols="12"
            lg="10"
            md="8"
            sm="12"
          >
            <v-text-field
              v-model="pessoa.rua"
              type="text"
              label="Rua/ Avenida"
              outlined
              dense
            >
            </v-text-field>
          </v-col>
          <v-col
            cols="12"
            lg="2"
            md="4"
            sm="12"
          >
            <v-text-field
              v-model="pessoa.numero"
              type="text"
              label="Número"
              outlined
              dense
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row class="pl-1">
          <v-col
            cols="12"
            lg="6"
            md="6"
            sm="12"
          >
            <v-text-field
              v-model="pessoa.complemento"
              type="text"
              label="Complemento"
              outlined
              dense
            >
            </v-text-field>
          </v-col>
          <v-col
            cols="12"
            lg="6"
            md="6"
            sm="12"
          >
            <v-text-field
              v-model="pessoa.ponto_referencia"
              type="text"
              label="Ponto de referência"
              outlined
              dense
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row class="pl-1">
          <v-col
            cols="12"
            lg="4"
            md="4"
            sm="12"
          >
            <v-autocomplete
              v-model="pessoa.tipo_residencia"
              :items="tpResidencia"
              label="Tipo de imóvel"
              required
              outlined
              dense
              @change="loadFuncaoResidencia()"
            >
            </v-autocomplete>
          </v-col>
          <v-col
            cols="12"
            lg="4"
            md="4"
            sm="12"
            v-if="res === 'financiada' || res==='alugada'"
          >
            <v-text-field
              v-model="pessoa.valor"
              currency="BRL"
              label="Valor.:"
              outlined
              dense
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row class="pl-1">
          <v-col
            cols="12"
            lg="12"
            md="12"
            sm="12"
            v-if="res === 'outros' || res==='cedida'"
          >
            <v-text-field
              v-model="pessoa.ds_outros"
              type="text"
              :label="`${dsLabel}`"
              outlined
              dense
            >
            </v-text-field>
          </v-col>
        </v-row>
      </v-form>
      <v-card-actions>
        <v-btn
          v-if="!codigo"
          class="my-2"
          :disabled="!btnSave"
          @click="save"
          color="success"
        >
          Salva
        </v-btn>
        <v-btn
          v-if="codigo"
          class="my-2"
          @click="update"
          color="success"
        >
          Atualizar
        </v-btn>
        <v-btn
          class="ml-2"
          color="blue-grey"
          @click="reset"
        >
          Limpar
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-card>
      <v-dialog
        v-model="dialog"
        transition="dialog-bottom-transition"
        fullscreen
      >
        <template v-slot:default="dialog">
          <v-card>
            <v-toolbar
              color="primary"
              dark
            >
              Pesquisar pessoas cadastradas
            </v-toolbar>
            <v-card-title>
              <v-card-title>
                Pesquisar
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Filtrar"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="filtro"
              :search="search"
            >
              <template v-slot:[`item.actions`]="{ item }">
                <v-icon
                  medium
                  color="primary"
                  class="mr-2"
                  @click="loadPessoaFilter(item)"
                >
                  mdi-square-edit-outline
                </v-icon>
                <v-icon
                  medium
                  color="error"
                  class="mr-2"
                  @click="loadPessoaFilter(item, 'remove')"
                >
                  mdi-delete
                </v-icon>
              </template>
            </v-data-table>
            <v-card-actions class="justify-end">
              <v-btn
                color="error"
                @click="dialog.value = false"
              >Fechar</v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>
    </v-card>
    <v-card class="px-5 borda-vm">
      <v-row justify="space-around">
        <v-col cols="auto">
          <v-dialog
            v-model="editPass"
            transition="dialog-top-transition"
            max-width="470"
          >
            <template v-slot:default="dialog">
              <v-card>
                <v-toolbar
                  color="primary"
                  dark
                >
                  Redefinição de senha
                </v-toolbar>
                <div class="form-pass mx-auto mt-1">
                  <v-form>
                    <v-row
                      justify="space-around"
                      class="px-6 mx-6"
                    >
                      <v-col cols="12">
                        <v-text-field
                          class="py-1 text-field"
                          v-model="pass.password"
                          label="Nova senha"
                          type="password"
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          class="py-1 text-field"
                          v-model="pass.confirmPassword"
                          label="Confime a senha"
                          type="password"
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-form>
                </div>
                <v-card-actions class="justify-end py-6">
                  <v-btn
                    color="success"
                    class="mr-4"
                    @click.prevent="updatePass()"
                  >
                    <v-icon left>
                      mdi-content-save
                    </v-icon>
                    Salvar
                  </v-btn>
                  <v-btn
                    color="danger"
                    class="mr-4"
                    @click="dialog.value = false, loadClose()"
                  >
                    Sair
                  </v-btn>
                </v-card-actions>
              </v-card>
            </template>
          </v-dialog>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import PageTitle from '@/components/template/PageTitle'
import axios from 'axios'
import { baseApiUrl, showError } from '@/global'
import { uuid } from 'vue-uuid'
import { mapState } from 'vuex'
const { cpf, cnpj } = require('cpf-cnpj-validator')
export default {
  name: 'Pessoas',
  components: { PageTitle },
  computed: mapState(['user']),
  data: () => ({
    dialog: false,
    editPass: false,
    search: '',
    uuid: '',
    verCpf: false,
    verCnpj: false,
    valid: true,
    codigo: '',
    btnSave: false,
    tipo: 'pfisica',
    res: '',
    vLabel: '',
    dsLabel: '',
    nameLabel: '',
    color: 'null',
    cpf: '###.###.###-##',
    val: '999.999,99',
    cpfMae: '###.###.###-##',
    cnpj: '##.###.###/####-##',
    fone: '(##)####-####',
    cel: '(##)#####-####',
    cep: '##.###-###',
    pessoa: {},
    pass: {},
    tPessoa: [],
    selected: 1,
    raca: [],
    instrucao: [],
    instituicao: [],
    atuacao: [],
    filtro: [],
    show1: false,
    show2: true,
    password: 'Password',
    rules: {
      required: value => !!value || 'Este campo é obrigatório',
      min: v => v.length >= 6 || 'A senha deve conter pelo menos 6 caracteres',
      emailMatch: () => (`A cofirmação é diferente da senha!`)
    },
    headers: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Nome', value: 'nome' },
      { text: 'E-mail', value: 'email' },
      { text: 'Cpf / Cgc', value: 'cgc_txt' },
      { text: 'Rg', value: 'rg' },
      { text: 'Nis', value: 'nis' },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    genero: [
      { value: 'M', text: 'Masculino' },
      { value: 'F', text: 'Feminino' }
    ],
    estadoCivil: [
      { value: 'Solteiro', text: 'Solteiro' },
      { value: 'Casado', text: 'Casado' },
      { value: 'Divorciado', text: 'Divorciado' },
      { value: 'Viúvo', text: 'Viúvo' }
    ],
    tpResidencia: [
      { value: 'PQ', text: 'Própria quitada' },
      { value: 'Pf', text: 'Própria financiada' },
      { value: 'Pa', text: 'Alugada' },
      { value: 'Cd', text: 'Cedida' },
      { value: 'Ot', text: 'Outros' }
    ],
    estados: [],
    cidades: []
  }),
  methods: {
    save () {
      axios.post(`${baseApiUrl}/adm-cad-pessoas`, this.pessoa)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.reset()
        })
        .catch(showError)
    },
    update () {
      const id = this.pessoa.uuid
      axios.put(`${baseApiUrl}/adm-adm-dados-pessoas-update/${id}`, this.pessoa)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.reset()
        })
        .catch(showError)
    },
    updatePass () {
      const id = this.pessoa.uuid
      axios.put(`${baseApiUrl}/adm-adm-dados-pessoas-a4d8-e9c580/${id}`, this.pass)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.editPass = false
        })
        .catch(showError)
    },
    reset () {
      this.pessoa = {}
      this.codigo = ''
      this.tpRes = ''
      this.pessoa.tipo_pessoa = 1
      this.loadFuncaoPessoa()
      this.loadFuncaoResidencia()
      this.pessoa.uuid = uuid.v1()
      this.pessoa.esic = true
      this.pessoa.auxilio = true
      this.btnSave = false
    },
    formataCpf () {
      const cpff = this.pessoa.cgc_txt
      const ccpf = cpf.isValid(cpff)
      const number = cpf.strip(cpff)
      if (ccpf === true) {
        this.pessoa.cgc = number
        this.color = `border: solid 1px #ced4da`
        this.btnSave = true
      } else {
        this.color = `border: solid 1px red !important`
      }
    },
    formataCnpj () {
      const cnpjj = this.pessoa.cgc_txt
      const ccnpj = cnpj.isValid(cnpjj)
      const number = cnpj.strip(cnpjj)
      if (ccnpj === true) {
        this.pessoa.cgc = number
        this.color = `border: solid 1px #ced4da`
        this.btnSave = true
      } else {
        this.color = `border: solid 1px red !important`
      }
    },
    loadFuncaoPessoa () {
      let codigo = this.codigo
      let pessoa = this.pessoa.tipo_pessoa
      if (pessoa === 1) {
        if (codigo === '') {
          this.verCpf = true
        } else {
          this.verCpf = false
        }
        this.verCnpj = false
        this.tipo = 'pfisica'
        this.nameLabel = 'Nome.'
      } else if (pessoa === 2) {
        if (codigo === '') {
          this.verCnpj = true
        } else {
          this.verCnpj = false
        }
        this.verCpf = false
        this.tipo = 'pjuridica'
        this.nameLabel = 'Razão social.'
        this.loadInstituicao()
        this.loadAtuacao()
      }
    },
    loadFuncaoResidencia () {
      const tpRes = this.pessoa.tipo_residencia
      if (tpRes === 'Pf') {
        this.res = 'financiada'
        this.vLabel = 'Valor do financiamento.'
      } else if (tpRes === 'Pa') {
        this.res = 'alugada'
        this.vLabel = 'Valor do Aluguel.'
      } else if (tpRes === 'Cd') {
        this.res = 'cedida'
        this.dsLabel = 'Cedida por quem?.'
      } else if (tpRes === 'Ot') {
        this.res = 'outros'
        this.dsLabel = 'Descreva.'
      } else {
        this.res = ''
      }
    },
    loadPessoa () {
      const url = `${baseApiUrl}/tipo-de-pessoa`
      axios.get(url).then(res => {
        this.tPessoa = res.data.map(tPessoa => {
          return {
            value: tPessoa.id,
            text: `${tPessoa.id} - ${tPessoa.tipo}`
          }
        })
      })
    },
    loadInstrucao () {
      const url = `${baseApiUrl}/grau-de-escolaridade`
      axios.get(url).then(res => {
        this.instrucao = res.data.map(instrucao => {
          return {
            value: instrucao.id,
            text: `${instrucao.id} - ${instrucao.escolaridade}`
          }
        })
      })
    },
    loadRaca () {
      const url = `${baseApiUrl}/lista-raca-pessoa`
      axios.get(url).then(res => {
        this.raca = res.data.map(raca => {
          return {
            value: raca.id,
            text: `${raca.id} - ${raca.raca}`
          }
        })
      })
    },
    loadInstituicao () {
      const url = `${baseApiUrl}/tipo-de-instituicao`
      axios.get(url).then(res => {
        this.instituicao = res.data.map(instituicao => {
          return {
            value: instituicao.id,
            text: `${instituicao.id} - ${instituicao.instituicao}`
          }
        })
      })
    },
    loadAtuacao () {
      const url = `${baseApiUrl}/area-de-atuacao-da-instituicao`
      axios.get(url).then(res => {
        this.atuacao = res.data.map(atuacao => {
          return {
            value: atuacao.id,
            text: `${atuacao.id} - ${atuacao.atuacao}`
          }
        })
      })
    },
    loadEstados () {
      const url = `${baseApiUrl}/estados`
      axios.get(url).then(res => {
        this.estados = res.data.map(estados => {
          return {
            value: estados.sigla,
            text: estados.nome
          }
        })
      })
    },
    loadCidades () {
      const uf = this.pessoa.uf
      const url = `${baseApiUrl}/estados/${uf}`
      axios.get(url).then(res => {
        this.cidades = res.data
      })
    },
    loadFiltro () {
      const url = `${baseApiUrl}/adm-cad-filtro-pessoas`
      axios.get(url).then(res => {
        this.filtro = res.data
      })
    },
    loadPessoaFilter (filtro, mode = 'save') {
      this.codigo = filtro.id
      const id = filtro.uuid
      this.mode = mode
      const url = `${baseApiUrl}/adm-adm-dados-pessoas-update/${id}`
      axios.get(url).then(res => {
        this.pessoa = res.data
        this.dialog = false
        this.valid = true
        this.loadFuncaoResidencia()
        this.loadFuncaoPessoa()
      })
      console.log(filtro)
    },
    altPass () {
      this.editPass = true
    },
    loadDialog () {
      this.dialog = true
      this.loadFiltro()
    },
    loadUser () {
      this.loadPessoa()
      this.loadInstrucao()
      this.loadRaca()
      this.loadEstados()
      this.pessoa.usuario = this.user.id
      this.nameLabel = 'Nome.'
      this.pessoa.uuid = uuid.v1()
      this.pessoa.esic = true
      this.pessoa.auxilio = true
      this.pessoa.tipo_pessoa = 1
      this.codigo = ''
      this.loadFuncaoPessoa()
    }
  },
  mounted () {
    this.loadUser()
  }
}
</script>
